import { ReactElement } from 'react';
import dayjs from 'dayjs';
import { DATE_FORMAT, TIME_FORMAT } from '@/shared/constants/date';

const LastSyncDateCell = ({ lastSyncDate }: { lastSyncDate?: string }): ReactElement => {
	const date = lastSyncDate && dayjs(lastSyncDate);

	if (!date) return <></>;
	return (
		<>
			{date.format(DATE_FORMAT)}
			<br />
			{date.format(TIME_FORMAT)}
		</>
	);
};

export default LastSyncDateCell;
